<template>
  <div>
    <PageHeader>
      <template v-slot:header>組織情報設定</template>
      <template v-slot:annotation>
        組織情報を変更する場合は、名称を変更後、変更ボタンをクリックしてください。
      </template>
    </PageHeader>

    <div class="text-center px-3">
      <v-form ref="organization_form">
        <div style="text-align: left; padding: 0px; margin: 0px">
          <p><small>※基本的な組織情報を変更します。</small></p>
        </div>
        <v-row>
          <v-col cols="12" sm="6" md="3">
            <FormInputComponent
              label="組織名"
              v-model="organizationName"
              rules="required"
              :counter="10"
            />

            <FormInputComponent
              label="初期パスワード"
              type="password"
              v-model="initialPasswordEntry"
              rules="passwordRules"
              :counter="8"
            />
          </v-col>
        </v-row>
        <div v-if="isPurasunoki">
          <div style="text-align: left; padding: 0px; margin: 0px">
            <p>
              <small>※プラスの氣を入力する際の最小文字数を変更します。</small>
            </p>
          </div>
          <v-row>
            <v-col cols="12" sm="6" md="3" lg="2">
              <FormInputComponent
                label="プラスの氣入力最小文字数"
                v-model="commentMinString"
                rules="commentMinStringRules"
                type="number"
                :counter="4"
                clearable
                ref="commentMinString"
              />
            </v-col>
          </v-row>
        </div>
        <div v-if="isJinji">
          <div style="text-align: left; padding: 0px; margin: 0px">
            <p><small>※優先度1～5の名称を変更します。</small></p>
          </div>
          <v-row>
            <v-col cols="12" sm="6" md="3" lg="2">
              <FormInputComponent
                label="ユーザランク(優先度1)"
                v-model="userRankName1"
                rules="required"
                :counter="10"
              />
            </v-col>
            <v-col cols="12" sm="6" md="3" lg="2">
              <FormInputComponent
                label="ユーザランク(優先度2)"
                v-model="userRankName2"
                rules="required"
                :counter="10"
              />
            </v-col>
            <v-col cols="12" sm="6" md="3" lg="2">
              <FormInputComponent
                label="ユーザランク(優先度3)"
                v-model="userRankName3"
                rules="required"
                :counter="10"
              />
            </v-col>
            <v-col cols="12" sm="6" md="3" lg="2">
              <FormInputComponent
                label="ユーザランク(優先度4)"
                v-model="userRankName4"
                rules="required"
                :counter="10"
              />
            </v-col>
            <v-col cols="12" sm="6" md="3" lg="2">
              <FormInputComponent
                label="ユーザランク(優先度5)"
                v-model="userRankName5"
                rules="required"
                :counter="10"
              />
            </v-col>
          </v-row>
          <div style="text-align: left; padding: 0px; margin: 0px">
            <p>
              <small>※人事考課シートのタイトル名称を変更します。</small>
            </p>
          </div>
          <v-row>
            <v-col cols="12" sm="12" md="12" lg="4">
              <FormInputComponent
                label="総合目標タイトル1"
                v-model="totalGoalTitle1"
                rules="required"
                :counter="50"
              />
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="4">
              <FormInputComponent
                label="総合目標タイトル2"
                v-model="totalGoalTitle2"
                rules="required"
                :counter="50"
              />
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="4">
              <FormInputComponent
                label="総合目標タイトル3"
                v-model="totalGoalTitle3"
                rules="required"
                :counter="50"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" md="3" lg="2">
              <FormInputComponent
                label="人間力タイトル"
                v-model="humanPowerTitle"
                rules="required"
                :counter="10"
              />
            </v-col>
            <v-col cols="12" sm="6" md="3" lg="2">
              <FormInputComponent
                label="チャレンジ目標タイトル"
                v-model="challengeGoalTitle"
                rules="required"
                :counter="10"
              />
            </v-col>
            <v-col cols="12" sm="6" md="3" lg="2">
              <FormInputComponent
                label="総合目標タイトル"
                v-model="totalTargetTitle"
                rules="required"
                :counter="10"
              />
            </v-col>
            <v-col cols="12" sm="6" md="3" lg="2">
              <FormInputComponent
                label="振り返りタイトル"
                v-model="commentTitle"
                rules="required"
                :counter="10"
              />
            </v-col>
            <v-col cols="12" sm="6" md="3" lg="2">
              <FormInputComponent
                label="最終確認タイトル"
                v-model="lastConfirmTitle"
                rules="required"
                :counter="10"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" md="12" lg="4">
              <FormInputComponent
                label="課題自己_タイトル1"
                v-model="taskSelfTitle1"
                rules="required"
                :counter="20"
              />
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="4">
              <FormInputComponent
                label="課題自己_タイトル2"
                v-model="taskSelfTitle2"
                rules="required"
                :counter="20"
              />
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="4">
              <FormInputComponent
                label="課題自己_タイトル3"
                v-model="taskSelfTitle3"
                rules="required"
                :counter="20"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" md="12" lg="4">
              <FormInputComponent
                label="課題管理_タイトル1"
                v-model="taskManageTitle1"
                rules="required"
                :counter="20"
              />
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="4">
              <FormInputComponent
                label="課題管理_タイトル2"
                v-model="taskManageTitle2"
                rules="required"
                :counter="20"
              />
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="4">
              <FormInputComponent
                label="課題管理_タイトル3"
                v-model="taskManageTitle3"
                rules="required"
                :counter="20"
              />
            </v-col>
          </v-row>
          <!--
          <div style="text-align: left; padding: 0px; margin: 0px">
            <p>
              <small>※昇格・昇給データ出力の期間を変更します。</small>
            </p>
          </div>
          <v-row>
            <v-col
              cols="12"
              sm="6"
              md="3"
              lg="2"
              class="pt-0 pb-0 pl-3 pr-1 ma-0"
            >
              <v-select
                label="上期開始(年)"
                v-model="firstHalfStartY"
                item-text="label"
                item-value="value"
                :items="isYearLabels"
                outlined
                dense
              />
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="3"
              lg="1"
              class="pt-0 pb-0 pl-0 pr-1 ma-0"
            >
              <v-select
                label="月"
                v-model="firstHalfStartM"
                item-text="label"
                item-value="value"
                :items="isMonthLabels"
                outlined
                dense
              />
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="3"
              lg="1"
              class="pt-0 pb-0 pl-0 pr-0 ma-0"
            >
              <v-select
                label="日"
                v-model="firstHalfStartD"
                item-text="label"
                item-value="value"
                :items="isDayLabels"
                outlined
                dense
              />
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="3"
              lg="1"
              class="pt-2 pb-0 pl-0 pr-0 ma-0"
            >
              <p><B>～</B></p>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="3"
              lg="2"
              class="pt-0 pb-0 pl-3 pr-1 ma-0"
            >
              <v-select
                label="上期終了(年)"
                v-model="firstHalfEndY"
                item-text="label"
                item-value="value"
                :items="isYearLabels"
                outlined
                dense
              />
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="3"
              lg="1"
              class="pt-0 pb-0 pl-0 pr-1 ma-0"
            >
              <v-select
                label="月"
                v-model="firstHalfEndM"
                item-text="label"
                item-value="value"
                :items="isMonthLabels"
                outlined
                dense
              />
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="3"
              lg="1"
              class="pt-0 pb-0 pl-0 pr-0 ma-0"
            >
              <v-select
                label="日"
                v-model="firstHalfEndD"
                item-text="label"
                item-value="value"
                :items="isDayLabels"
                outlined
                dense
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col
              cols="12"
              sm="6"
              md="3"
              lg="2"
              class="pt-0 pb-0 pl-3 pr-1 ma-0"
            >
              <v-select
                label="下期開始(年)"
                v-model="secondHalfStartY"
                item-text="label"
                item-value="value"
                :items="isYearLabels"
                outlined
                dense
              />
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="3"
              lg="1"
              class="pt-0 pb-0 pl-0 pr-1 ma-0"
            >
              <v-select
                label="月"
                v-model="secondHalfStartM"
                item-text="label"
                item-value="value"
                :items="isMonthLabels"
                outlined
                dense
              />
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="3"
              lg="1"
              class="pt-0 pb-0 pl-0 pr-0 ma-0"
            >
              <v-select
                label="日"
                v-model="secondHalfStartD"
                item-text="label"
                item-value="value"
                :items="isDayLabels"
                outlined
                dense
              />
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="3"
              lg="1"
              class="pt-2 pb-0 pl-0 pr-0 ma-0"
            >
              <p><B>～</B></p>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="3"
              lg="2"
              class="pt-0 pb-0 pl-3 pr-1 ma-0"
            >
              <v-select
                label="下期終了(年)"
                v-model="secondHalfEndY"
                item-text="label"
                item-value="value"
                :items="isYearLabels"
                outlined
                dense
              />
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="3"
              lg="1"
              class="pt-0 pb-0 pl-0 pr-1 ma-0"
            >
              <v-select
                label="月"
                v-model="secondHalfEndM"
                item-text="label"
                item-value="value"
                :items="isMonthLabels"
                outlined
                dense
              />
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="3"
              lg="1"
              class="pt-0 pb-0 pl-0 pr-0 ma-0"
            >
              <v-select
                label="日"
                v-model="secondHalfEndD"
                item-text="label"
                item-value="value"
                :items="isDayLabels"
                outlined
                dense
              />
            </v-col>
          </v-row>
          -->
        </div>
      </v-form>
      <v-row>
        <v-col cols="6" sm="6" md="4" lg="2">
          <Button @click="erntry_confirm" color="primary">変更</Button>
        </v-col>
      </v-row>
    </div>

    <Loader :loading="loading" />

    <DialogMessage ref="dialog" />

    <ConfirmDialog
      ref="confirm"
      title="組織情報編集"
      :message="confirmMessage"
      buttonMessage="OK"
      @confirm="editOrganizeInfo"
    >
    </ConfirmDialog>
  </div>
</template>

<script>
import axios from 'axios';
import config from '../../../const.js';
import moment from 'moment';
import message from '../../../message.js';
import ConfirmDialog from '@/components/Common/ConfirmMessage.vue';
import { getSessionStorageItem, encrypt256 } from '../../../common.js';
export default {
  components: {
    ConfirmDialog,
  },
  data() {
    return {
      userInfo: {},
      loading: false,
      confirmMessage: null,
      organizationKey: null,
      organizationName: '',
      initialPassword: '',
      initialPasswordEntry: '',
      commentMinString: 0,
      startOrganizationDate: null,
      endOrganizationDate: null,
      expiration: null,
      userRankName1: '',
      userRankName2: '',
      userRankName3: '',
      userRankName4: '',
      userRankName5: '',
      totalGoalTitle1: '',
      totalGoalTitle2: '',
      totalGoalTitle3: '',
      humanPowerTitle: '',
      challengeGoalTitle: '',
      totalTargetTitle: '',
      commentTitle: '',
      lastConfirmTitle: '',
      taskSelfTitle1: '',
      taskSelfTitle2: '',
      taskSelfTitle3: '',
      taskManageTitle1: '',
      taskManageTitle2: '',
      taskManageTitle3: '',
      createdAt: null,
      updateAt: null,
      isPurasunoki: false,
      isJinji: false,
      // 昇給・昇格
      isYearLabels: [
        { label: config.CURRENT_YEAR_NAME, value: config.CURRENT_YEAR_VAL },
        { label: config.NEXT_YEAR_NAME, value: config.NEXT_YEAR_VAL },
      ],
      isMonthLabels: [
        { label: '01', value: '01' },
        { label: '02', value: '02' },
        { label: '03', value: '03' },
        { label: '04', value: '04' },
        { label: '05', value: '05' },
        { label: '06', value: '06' },
        { label: '07', value: '07' },
        { label: '08', value: '08' },
        { label: '09', value: '09' },
        { label: '10', value: '10' },
        { label: '11', value: '11' },
        { label: '12', value: '12' },
      ],
      isDayLabels: [
        { label: '01', value: '01' },
        { label: '02', value: '02' },
        { label: '03', value: '03' },
        { label: '04', value: '04' },
        { label: '05', value: '05' },
        { label: '06', value: '06' },
        { label: '07', value: '07' },
        { label: '08', value: '08' },
        { label: '09', value: '09' },
        { label: '10', value: '10' },
        { label: '11', value: '11' },
        { label: '12', value: '12' },
        { label: '13', value: '13' },
        { label: '14', value: '14' },
        { label: '15', value: '15' },
        { label: '16', value: '16' },
        { label: '17', value: '17' },
        { label: '18', value: '18' },
        { label: '19', value: '19' },
        { label: '20', value: '20' },
        { label: '21', value: '21' },
        { label: '22', value: '22' },
        { label: '23', value: '23' },
        { label: '24', value: '24' },
        { label: '25', value: '25' },
        { label: '26', value: '26' },
        { label: '27', value: '27' },
        { label: '28', value: '28' },
        { label: '29', value: '29' },
        { label: '30', value: '30' },
        { label: '31', value: '31' },
      ],
      firstHalfStartDate: '',
      firstHalfEndDate: '',
      secondHalfStartDate: '',
      secondHalfEndDate: '',
      firstHalfStartY: '',
      firstHalfStartM: '',
      firstHalfStartD: '',
      firstHalfEndY: '',
      firstHalfEndM: '',
      firstHalfEndD: '',
      secondHalfStartY: '',
      secondHalfStartM: '',
      secondHalfStartD: '',
      secondHalfEndY: '',
      secondHalfEndM: '',
      secondHalfEndD: '',
    };
  },
  created() {
    const userInfo = getSessionStorageItem();
    this.userInfo = userInfo;
    this.get_organization();
    if (userInfo) {
      this.expiration = userInfo.ORGANIZATION_EXPIRATION;
    }
    if (this.expiration == config.EXPIRATION_PURASUNOKI) {
      // プラスの氣
      this.isPurasunoki = true;
      this.isJinji = false;
    } else if (this.expiration == config.EXPIRATION_JINJI) {
      // 人事考課
      this.isPurasunoki = false;
      this.isJinji = true;
    } else {
      // 両方
      this.isPurasunoki = true;
      this.isJinji = true;
    }
  },

  methods: {
    async get_organization() {
      this.loading = true;

      if (!this.userInfo) {
        this.$refs.dialog.open(
          'error',
          message.MSG_ERROR_SESSION + message.MSG_ERROR_SESSION_DETAIL
        );
        this.loading = false;
        return;
      }

      await axios
        .get(
          config.CONNECT_URL +
            '/Encouragements/manage/organization/' +
            this.userInfo.SESSION_ID +
            '/' +
            this.userInfo.USER_ID +
            '/' +
            this.userInfo.ORGANIZATION_KEY
        )
        .then((response) => {
          // 組織データ取得
          const items = response.data[0];
          this.organizationKey = items.ORGANIZATION_KEY;
          this.organizationName = items.ORGANIZATION_NAME;
          this.initialPassword = items.INITIAL_PASSWORD;
          this.initialPasswordEntry = items.INITIAL_PASSWORD.substr(0, 10);
          this.commentMinString = Number(items.COMMENT_MIN_STRING);
          this.startOrganizationDate = items.START_OPERATING_DATE;
          this.endOrganizationDate = items.END_OPERATING_DATE;
          this.expiration = items.EXPIRATION;
          this.userRankName1 = items.USER_RANK_NAME_1;
          this.userRankName2 = items.USER_RANK_NAME_2;
          this.userRankName3 = items.USER_RANK_NAME_3;
          this.userRankName4 = items.USER_RANK_NAME_4;
          this.userRankName5 = items.USER_RANK_NAME_5;
          this.totalGoalTitle1 = items.TOTAL_GOAL_TITLE_1;
          this.totalGoalTitle2 = items.TOTAL_GOAL_TITLE_2;
          this.totalGoalTitle3 = items.TOTAL_GOAL_TITLE_3;
          this.humanPowerTitle = items.HUMAN_POWER_TITLE;
          this.challengeGoalTitle = items.CHALLENGE_GOAL_TITLE;
          this.totalTargetTitle = items.TOTAL_TARGET_TITLE;
          this.commentTitle = items.COMMENT_TITLE;
          this.lastConfirmTitle = items.LAST_CONFIRM_TITLE;
          this.taskSelfTitle1 = items.TASK_SELF_TITLE_1;
          this.taskSelfTitle2 = items.TASK_SELF_TITLE_2;
          this.taskSelfTitle3 = items.TASK_SELF_TITLE_3;
          this.taskManageTitle1 = items.TASK_MANAGE_TITLE_1;
          this.taskManageTitle2 = items.TASK_MANAGE_TITLE_2;
          this.taskManageTitle3 = items.TASK_MANAGE_TITLE_3;
          this.updateAt = items.CREATED_AT;
          this.createdAt = items.UPDATED_AT;
        })
        .catch((error) => {
          let errStr = '';
          if (error.response.status == 404) {
            errStr = message.MSG_INFO_ORGANIZATION_NOT_FOUND;
            this.$refs.dialog.open('info', errStr);
          } else if (error.response.status == 400) {
            errStr = message.MSG_ERROR_SESSION + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM + error;
            this.$refs.dialog.open('error', errStr);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    erntry_confirm() {
      // 入力チェック
      if (!this.$refs.organization_form.validate()) {
        return;
      }
      /*
      // ##### 昇給昇格入力データ変数初期化
      this.firstHalfStartDate = '';
      this.firstHalfEndDate = '';
      this.secondHalfStartDate = '';
      this.secondHalfEndDate = '';

      // ##### 昇給昇格入力データ必須チェック
      // 上期開始
      if (!this.firstHalfStartY) {
        this.$refs.dialog.open(
          'info',
          '上期開始(年)が選択されていません。上期開始(年)を選択して下さい。'
        );
        return;
      }
      if (!this.firstHalfStartM) {
        this.$refs.dialog.open(
          'info',
          '上期開始(月)が選択されていません。上期開始(月)を選択して下さい。'
        );
        return;
      }
      if (!this.firstHalfStartD) {
        this.$refs.dialog.open(
          'info',
          '上期開始(日)が選択されていません。上期開始(日)を選択して下さい。'
        );
        return;
      }
      // 上期終了
      if (!this.firstHalfEndY) {
        this.$refs.dialog.open(
          'info',
          '上期終了(年)が選択されていません。上期終了(年)を選択して下さい。'
        );
        return;
      }
      if (!this.firstHalfEndM) {
        this.$refs.dialog.open(
          'info',
          '上期終了(月)が選択されていません。上期終了(月)を選択して下さい。'
        );
        return;
      }
      if (!this.firstHalfEndD) {
        this.$refs.dialog.open(
          'info',
          '上期終了(日)が選択されていません。上期終了(日)を選択して下さい。'
        );
        return;
      }

      // 下期開始
      if (!this.secondHalfStartY) {
        this.$refs.dialog.open(
          'info',
          '下期開始(年)が選択されていません。下期開始(年)を選択して下さい。'
        );
        return;
      }
      if (!this.secondHalfStartM) {
        this.$refs.dialog.open(
          'info',
          '下期開始(月)が選択されていません。下期開始(月)を選択して下さい。'
        );
        return;
      }
      if (!this.secondHalfStartD) {
        this.$refs.dialog.open(
          'info',
          '下期開始(日)が選択されていません。下期開始(日)を選択して下さい。'
        );
        return;
      }
      // 下期終了
      if (!this.secondHalfEndY) {
        this.$refs.dialog.open(
          'info',
          '下期終了(年)が選択されていません。下期終了(年)を選択して下さい。'
        );
        return;
      }
      if (!this.secondHalfEndM) {
        this.$refs.dialog.open(
          'info',
          '下期終了(月)が選択されていません。下期終了(月)を選択して下さい。'
        );
        return;
      }
      if (!this.secondHalfEndD) {
        this.$refs.dialog.open(
          'info',
          '下期終了(日)が選択されていません。下期終了(日)を選択して下さい。'
        );
        return;
      }

      // ##### 昇給昇格入力データ日付妥当性チェック
      let dateStr = '/';
      let firstHalfStartDateTmp = makeDateStr(
        this.firstHalfStartY,
        this.firstHalfStartM,
        this.firstHalfStartD,
        dateStr
      );

      let firstHalfEndDateTmp = makeDateStr(
        this.firstHalfEndY,
        this.firstHalfEndM,
        this.firstHalfEndD,
        dateStr
      );

      let secondHalfStartDateTmp = makeDateStr(
        this.secondHalfStartY,
        this.secondHalfStartM,
        this.secondHalfStartD,
        dateStr
      );

      let secondHalfEndDateTmp = makeDateStr(
        this.secondHalfEndY,
        this.secondHalfEndM,
        this.secondHalfEndD,
        dateStr
      );

      if (!checkDateStr(firstHalfStartDateTmp)) {
        this.$refs.dialog.open(
          'info',
          '上期開始年月日の日付が歴日ではありません(2000/2/31 など)。\n' +
            ' 正しい日付を入力してください。'
        );
        return;
      }

      if (!checkDateStr(firstHalfEndDateTmp)) {
        this.$refs.dialog.open(
          'info',
          '上期終了年月日の日付が歴日ではありません(2000/2/31 など)。\n' +
            ' 正しい日付を入力してください。'
        );
        return;
      }

      if (!checkDateStr(secondHalfStartDateTmp)) {
        this.$refs.dialog.open(
          'info',
          '下期開始年月日の日付が歴日ではありません(2000/2/31 など)。\n' +
            ' 正しい日付を入力してください。'
        );
        return;
      }

      if (!checkDateStr(secondHalfEndDateTmp)) {
        this.$refs.dialog.open(
          'info',
          '下期終了年月日の日付が歴日ではありません(2000/2/31 など)。\n' +
            ' 正しい日付を入力してください。'
        );
        return;
      }

      this.firstHalfStartDate =
        this.firstHalfStartY + this.firstHalfStartM + this.firstHalfStartD;
      this.firstHalfEndDate =
        this.firstHalfEndY + this.firstHalfEndM + this.firstHalfEndD;

      this.secondHalfStartDate =
        this.secondHalfStartY + this.secondHalfStartM + this.secondHalfStartD;
      this.secondHalfEndDate =
        this.secondHalfEndY + this.secondHalfEndM + this.secondHalfEndD;

      // ##### 昇給昇格入力データ日付比較チェック
      if (this.firstHalfStartDate >= this.firstHalfEndDate) {
        this.$refs.dialog.open(
          'info',
          '上期終了年月日の日付が不正です。\n' +
            ' 上期終了年月日には、上期開始年月日より未来の日付を設定してください。'
        );
        return;
      }
      */

      // 確認ダイアログ表示
      this.confirmMessage = '組織情報を変更しますか？';
      this.$refs.confirm.open();
    },
    editOrganizeInfo() {
      // ローディング画像表示
      this.loading = false;
      // ユーザ情報の取得
      let userInfo = getSessionStorageItem();
      // セッションチェック
      if (userInfo == null) {
        this.$refs.dialog.open(
          'error',
          message.MSG_ERROR_SESSION + message.MSG_ERROR_SESSION_DETAIL
        );
        this.loading = false;
        return;
      }
      // 更新日時設定
      this.updateAt = moment().format('YYYYMMDDHHmmss');

      // パスワード設定
      if (this.initialPassword != null && this.initialPassword.trim()) {
        let originalPassword = this.initialPassword.substr(0, 10);
        // パスワード設定
        if (originalPassword != this.initialPasswordEntry) {
          this.initialPassword = encrypt256(this.initialPasswordEntry);
        }
      } else {
        this.initialPassword = encrypt256(this.entryPassword);
      }

      //----- 組織情報更新リクエストPOST
      axios
        .post(config.CONNECT_URL + '/Encouragements/manage/organization/edit', {
          SESSION_ID: userInfo.SESSION_ID,
          SESSION_USER_ID: userInfo.USER_ID,

          ORGANIZATION_KEY: this.organizationKey,
          ORGANIZATION_NAME: this.organizationName,
          INITIAL_PASSWORD: this.initialPassword,
          COMMENT_MIN_STRING: this.commentMinString,
          START_OPERATING_DATE: this.startOrganizationDate,
          END_OPERATING_DATE: this.endOrganizationDate,
          EXPIRATION: this.expiration,
          USER_RANK_NAME_1: this.userRankName1,
          USER_RANK_NAME_2: this.userRankName2,
          USER_RANK_NAME_3: this.userRankName3,
          USER_RANK_NAME_4: this.userRankName4,
          USER_RANK_NAME_5: this.userRankName5,
          TOTAL_GOAL_TITLE_1: this.totalGoalTitle1,
          TOTAL_GOAL_TITLE_2: this.totalGoalTitle2,
          TOTAL_GOAL_TITLE_3: this.totalGoalTitle3,
          HUMAN_POWER_TITLE: this.humanPowerTitle,
          CHALLENGE_GOAL_TITLE: this.challengeGoalTitle,
          TOTAL_TARGET_TITLE: this.totalTargetTitle,
          COMMENT_TITLE: this.commentTitle,
          LAST_CONFIRM_TITLE: this.lastConfirmTitle,
          TASK_SELF_TITLE_1: this.taskSelfTitle1,
          TASK_SELF_TITLE_2: this.taskSelfTitle2,
          TASK_SELF_TITLE_3: this.taskSelfTitle3,
          TASK_MANAGE_TITLE_1: this.taskManageTitle1,
          TASK_MANAGE_TITLE_2: this.taskManageTitle2,
          TASK_MANAGE_TITLE_3: this.taskManageTitle3,
          CREATED_AT: this.createdAt,
          UPDATED_AT: this.updateAt,
        })
        .then((response) => {
          // ローディング画像終了
          this.loading = false;

          let msgStr = '';
          if (response.status == 200) {
            msgStr = message.MSG_INFO_ORGANIZE_ENTRY_COMPLETE;
            this.$refs.dialog.open('info', msgStr);
            this.$emit('edit');
          }
        })
        .catch((error) => {
          // ローディング画像終了
          this.loading = false;

          let errStr = '';
          if (error.status == 400) {
            errStr = message.MSG_ERROR_SESSION_ERROR + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM_ERROR + error;
            this.$refs.dialog.open('error', errStr);
          }
        });
    },
  },
};
</script>
